import { Box, Button, Typography, Grid, FormControlLabel, Switch } from '@mui/material';
import React, { useState, useRef, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ShowInformation from './subs/ShowInformation';
import { wrapperSx, placeholderHa } from './styles/cssHojaAtencion';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { setCargaDatos } from '../Redux/V2/ContratoRedux';
import Causas from './Causas';
import { Editor } from '@tinymce/tinymce-react'
import AddIcon from '@mui/icons-material/Add'
import { SkipNext } from '@mui/icons-material';

const HojaAtencion = ({ from, onChangeSave }) => {
  const pageRef = useRef(null);
  const dispatch = useDispatch();

  const [html, setHtml] = useState("");
  const [disable, setDisable] = useState(false);
  //const [disabledComponent, setDisabledComponent] = useState(false);

  const entrevista = useSelector((store) => store.contratoV2.Entrevista);
  const contratoCancelado = useSelector((store) => store.contratoV2.ContratoCancelado);
  const contratoFiniquitado = useSelector((store) => store.contratoV2.ContratoFiniquitado);
  const contratoFirmado = useSelector((store) => store.contratoV2.ContratoFirmado);
  const defendido = useSelector((store) => store.contratoV2.Defendido);
  const actualizacion = useSelector((store) => store.contratoV2.Actualizacion)

  // Estado local para controlar el switch
  const [nuevovalor, setNuevoValor] = useState(entrevista?.origen !== 'presencial');



  const disabledComponent = actualizacion?.actualizacion?.status == 1

  const bloqueadoTotalmente =
    !!contratoCancelado?.cancelado ||
    !!contratoFiniquitado?.finiquitado



  useEffect(() => {
    if (entrevista.hojaAtencion) {
      setHtml(entrevista.hojaAtencion);
    }

    if (entrevista.id && defendido.id == null) {
      dispatch(setCargaDatos("Defendido", "get", entrevista.id));
    }

    // Sincronizar el switch con el valor inicial de la entrevista
    setNuevoValor(entrevista?.origen !== 'presencial');
  }, [entrevista]);



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (bloqueadoTotalmente) {
      Swal.fire({
        icon: 'info',
        title: 'Edición bloqueada',
        text: 'El contrato está cancelado, finiquitado o firmado. No es posible guardar cambios.'
      });
      return;
    }

    if (html && html.replace("<p><br></p>", "").length > 0) {
      const exito = await dispatch(setCargaDatos("Entrevista", "patch", { Id: entrevista.id, HojaAtencion: html }));

      if (exito) {
        Swal.fire({ icon: "success", title: "Hoja de Atención Actualizada" });
        if (exito) onChangeSave(from);
      }
    } else {
      Swal.fire({
        title: 'Hoja de atención vacía, no puede continuar.',
        icon: 'warning',
        confirmButtonText: 'Entendido'
      });
      return;
    }
  };

  const handleEditarOrigen = async () => {
    // Cambiar el valor local del switch
    if (bloqueadoTotalmente) {
      Swal.fire({
        icon: 'info',
        title: 'Edición bloqueada',
        text: 'El contrato está cancelado, finiquitado o firmado. No es posible cambiar el origen.'
      });
      return;
    }

    const nuevo = !nuevovalor;
    setNuevoValor(nuevo);

    // Guardar en backend
    const exito = await dispatch(setCargaDatos("Entrevista", "put", { Id: entrevista.id, Origen: nuevo ? "remoto" : "presencial" }));

    if (exito) {
      Swal.fire({ icon: "success", title: "Origen Actualizado" });
      //if (exito) onChangeSave(from);
    }
  };

  return (
    <>
      <ShowInformation from={from} />
      <br />
      <Causas />
      <Box sx={wrapperSx} className="bg-white">
        {/* Switch de Remoto/Presencial */}
        <br />
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", paddingBottom: "10px" }}>
          <FormControlLabel
            control={
              <Switch
                checked={nuevovalor} // estado local
                name="origenEntrevista"
                color="primary"
                onClick={handleEditarOrigen} // manejar clic
                disabled={bloqueadoTotalmente || (contratoFirmado?.firmado && !disabledComponent)} // 🔒 deshabilitado si está bloqueadoTotalmente
              />
            }
            label={nuevovalor ? "Remoto" : "Presencial"} // actualizar label
            labelPlacement="start" // texto a la izquierda, switch a la derecha
          />
        </Grid>

        <Box>
          <div ref={pageRef} className="page">
            {/* Contenedor que scrollea */}
            <div >
              <Editor
                //apiKey="no89skh86yibdbm71do29mqz4ldjyv6h6ix52vctyv798ztf"
                tinymceScriptSrc='/tinymce/tinymce.min.js'
                licenseKey='GPL'
                value={html}
                onEditorChange={setHtml}
                init={{
                  height: 600,
                  menubar: true,
                  plugins: [
                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                    'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                  ],
                  toolbar: 'undo redo | blocks | ' +
                    'bold italic forecolor | alignleft aligncenter ' +
                    'alignright alignjustify | bullist numlist outdent indent | ' +
                    'removeformat | help',
                  readonly: bloqueadoTotalmente ? 1 : 0, // 🔒 Editor en solo lectura si está bloqueadoTotalmente
                  branding: false
                }}
                disabled={bloqueadoTotalmente} // (prop soportada por tinymce-react)
              />
            </div>
          </div>
        </Box>
      </Box>

      {/* Botón de guardar */}
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, alignItems: 'center', p: 2 }}
      >

        {bloqueadoTotalmente ? (
          <Button
            type="button"
            variant="contained"
            color="success"
            startIcon={<SkipNext />}
            size="large"
            onClick={() => onChangeSave(0)}
          >
            Continuar
          </Button>
        ) : (
          <Button type="submit"
            variant="contained"
            startIcon={<AddIcon />}  >
            Guardar y continuar
          </Button>
        )}


      </Box>

    </>
  );
};

export default HojaAtencion;
